import { IP } from 'entities/ip';
import { Selectors as Router } from 'router';
import { Client } from 'services/apiGatewayClient';
import { createService } from 'services/genericAPIGatewayService';
import { State } from 'store';
import { mapMpsWhitelistedIPResponseToEntity } from '../adapters';
import { MpsWhitelistedIPResponse } from '../types';
import { Service } from './services';

const client = new Client<IP, IP, MpsWhitelistedIPResponse, MpsWhitelistedIPResponse[]>({
  mapToRequest: (x: IP) => x,
  mapFromResponse: mapMpsWhitelistedIPResponseToEntity,
  mapFromListResponse: (data: MpsWhitelistedIPResponse[]) =>
    Array.isArray(data) ? data.map(mapMpsWhitelistedIPResponseToEntity) : [],
});

const endpointCreator = (state: State) => {
  const siteId = Router.getSiteId(state);
  const campaignId = Router.getCampaignId(state);
  return siteId && campaignId ? `/mps/sites/${siteId}/campaigns/${campaignId}/whitelisted-ips` : undefined;
};

export const { Actions, Selectors, Sagas } = createService<IP, Service.IpWhitelist>({
  service: Service.IpWhitelist,
  client,
  endpointCreator,
  stateConverter: (state: State) => state.campaigns.ipWhitelist,
  sagas: ['CREATE', 'DELETE', 'GET_COLLECTION'],
});
